import React from 'react';

import {
  Box,
  Radio,
  Select,
  MenuItem,
  FormLabel,
  TextField,
  RadioGroup,
  Typography,
  FormControl,
  FormControlLabel,
  SelectChangeEvent,
} from '@mui/material';

import useLocales from 'src/hooks/useLocales';

// ----------------------------------------------------------------------

export enum SIGNED_FILE_TYPE {
  ASICE = 2,
  ADOC = 3,
  BDOC = 4,
  EDOC = 5,
}

export enum ADOC_TYPE {
  GEDOC = 1,
  BEDOC = 3,
}

type DocumentComposeArchiveProps = {
  name: string;
  setName: (name: string) => void;
  signedFileType: number;
  setSignedFileType: (type: number) => void;
  adocType: number;
  setAdocType: (type: number) => void;
};

const DocumentComposeArchive: React.FC<DocumentComposeArchiveProps> = ({
  name,
  setName,
  signedFileType,
  setSignedFileType,
  adocType,
  setAdocType,
}) => {
  const { t } = useLocales();

  const handleSignedFileTypeChange = (type: number) => {
    setSignedFileType(type);
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <TextField
        id="SJm4Xkom"
        label={t('documents.fields.documentName')}
        variant="outlined"
        value={name}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
          setName(event.target.value);
        }}
      />

      <FormControl>
        <FormLabel id="ai5GHKvI">{t('documents.typeOfDocument')}</FormLabel>
        <RadioGroup
          row
          value={signedFileType}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            const { value } = event.target as HTMLInputElement;

            setSignedFileType(Number(value));
          }}
        >
          <FormControlLabel
            value={SIGNED_FILE_TYPE.ADOC}
            onClick={() => handleSignedFileTypeChange(3)}
            control={<Radio />}
            label={
              <Box sx={{ display: 'flex', justifyContent: 'left', alignItems: 'center', gap: 1 }}>
                ADoc:
                <FormControl variant="standard" sx={{ m: 1, minWidth: 80 }}>
                  <Select
                    size="small"
                    id="lqMOXcPy"
                    value={adocType.toString()}
                    onChange={(event: SelectChangeEvent) => setAdocType(Number(event.target.value))}
                  >
                    <MenuItem value={ADOC_TYPE.GEDOC}>
                      <Typography variant="body2">GeDOC</Typography>
                    </MenuItem>

                    <MenuItem value={ADOC_TYPE.BEDOC}>
                      <Typography variant="body2">BeDOC</Typography>
                    </MenuItem>
                  </Select>
                </FormControl>
              </Box>
            }
          />
          <FormControlLabel
            value={SIGNED_FILE_TYPE.ASICE}
            onClick={() => handleSignedFileTypeChange(2)}
            control={<Radio />}
            label="ASICE"
          />
          <FormControlLabel
            value={SIGNED_FILE_TYPE.BDOC}
            onClick={() => handleSignedFileTypeChange(4)}
            control={<Radio />}
            label="BDoc"
          />
          <FormControlLabel
            value={SIGNED_FILE_TYPE.EDOC}
            onClick={() => handleSignedFileTypeChange(5)}
            control={<Radio />}
            label="EDoc"
          />
        </RadioGroup>
      </FormControl>
    </Box>
  );
};

export default DocumentComposeArchive;
